import { Component, OnInit } from '@angular/core';
import {orderCall} from '../../../../../core/utils/utils';

@Component({
  selector: 'app-pzu-banner',
  templateUrl: './pzu-banner.component.html',
  styleUrls: ['./pzu-banner.component.scss']
})
export class PzuBannerComponent implements OnInit {

  get logoUrl(): string {
    return './assets/images/logo/PZU_logo.png';
  }

  get redirectUrl(): string {
    return 'https://ad.doubleclick.net/ddm/trackclk/N368201.3650186KIOSKPOLIS/B24122663.294657114;dc_trk_aid=487800754;dc_trk_cid=142798790;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755';
  }

  constructor() { }

  ngOnInit() {
  }

  visitPZUWebsite(): void {
    window.open(this.redirectUrl, '_blank');
  }

  orderCall(): void {
    orderCall();
  }

}
